import Vue from 'vue'
import VueRouter from 'vue-router'
import index from './components/index.vue'
import introduction from './components/introduction.vue'

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalPush.call(this, location).catch(err => err)
};
export const routes = [
  {
    path: '/',
    name: 'indexComponent',
    meta: {},
    component: index
  },
  {
    path: '/introduction',
    name: 'introduction',
    meta: {},
    component: introduction
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
router.beforeEach((to, from, next) => {
  if (to.path.endsWith(' ')) {
    let path = to.path.trim();
    next({path: path})
  } else if (to.path.endsWith('%20')) {
    let path = to.path.substring(0, to.path.length - 3);
    next({path: path})
  } else {
    next()
  }
})
